/**
 * Canonical field-key normalization for schema definitions.
 *
 * Schema field names have to be safe identifiers — they become JSON keys and,
 * for SQL schemas, real Postgres columns — so the schema builder rewrites
 * whatever a user types into this form. A CSV header like `DIV CODE` is stored
 * as `div_code`.
 *
 * That means anything matching file columns to schema fields has to compare
 * through this function rather than by raw string, which is why it lives in
 * shared-utils instead of next to the builder UI.
 */
export function normalizeSchemaFieldKey(raw: string): string {
  let s = raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, "_")
    .replace(/^_+|_+$/g, "");
  if (!s) return "";
  if (/^[0-9]/.test(s) || s === "payload") {
    s = `field_${s === "payload" ? "data" : s}`;
  }
  if (!/^[a-z]/.test(s)) {
    s = `field_${s}`;
  }
  return s;
}
